<template>
  <div class="">
    <!-- <div class="absolute bg-design1 mob-hidden">
      <img
        src="../../../../assets/images/bg-des/bgd1.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design2 mob-hidden">
      <img src="../../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
    </div>
    <div class="absolute bg-design3 mob-hidden">
      <img
        src="../../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="bottom-44 right-0 absolute mob-hidden">
      <img
        src="../../../../assets/images/caregiver/medc-dots.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <div class="container">
      <div class="mb-4">
        <p
          class="title fsize36 sm-fsize20 lg:font-normal md:font-normal font-bold"
        >
          Shopping Cart
        </p>
        <hr />
      </div>
      <div class="w-full px-4 rounded-xl" v-if="cartData == 0">
        <NoData />
      </div>
      <div class="lg:flex gap-2" v-else>
        <div class="lg:w-2/3 w-full rounded-xl">
          <div class="bg-white">
            <div
              class="cust-shadow-FAQ lg:p-6 md:p-4 p-2 rounded-lg w-full my-6"
              v-for="(item, index) in cartData"
              :key="index"
            >
              <div
                class="lg:flex lg:flex-wrap flex w-full"
                v-for="(items, index) in item.course"
                :key="index"
              >
                <div class="flex items-center w-full">
                  <div class="md:w-1/5 w-1/2 flex items-center">
                    <div class="">
                      <img
                        :src="$imageURL + '/' + items.icone"
                        alt="Icon"
                        class="cartcrsimg rounded-lg mx-auto"
                      />
                    </div>
                  </div>
                  <div class="md:flex items-center w-4/5 justify-between">
                    <div class="">
                      <div class="pl-6">
                        <p
                          class="text-black fsize18 sm-fsize16 font-bold text-base ellipsis-2 pr-4"
                        >
                          {{ items.name }}
                        </p>
                        <p
                          class="font-medium cartfooter sm-fsize12 md:mt-1 mt-1"
                        >
                          By
                          {{
                            items.author
                              .map((data) => {
                                if (data.userId) {
                                  return (
                                    data.userId.firstname +
                                    " " +
                                    data.userId.lastname
                                  );
                                }
                              })
                              .toString()
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="flex items-center gap-2 md:w-2/5 pl-6 md:pl-0">
                      <!-- <p
                        class="md:text-center text-sm font-normal text-primary line-through"
                      >
                        Rs {{ items.price ? items.price : 0 }}
                      </p> -->
                      <p
                        class="md:text-center lg:text-lg sm-fsize14 font-normal text-primary line-through"
                      >
                        Rs. {{ items.price ? items.price : 0 }}
                      </p>
                      <p
                        class="md:text-center text-lg font-bold text-primary md:mt-0"
                      >
                        Rs. {{ items.discountPrice ? items.discountPrice : 0 }}
                        <!-- <template
                          v-if="
                            Object.keys(getUserByUserId).length !== 0 &&
                            Object.hasOwn(getUserByUserId, 'currentMembership')
                          "
                        >
                          &#8377;{{
                            items.discountPrice
                              ? (
                                  items.discountPrice -
                                  (getUserByUserId.currentMembership.discount /
                                    100) *
                                    items.discountPrice
                                ).toFixed(2)
                              : 0
                          }}
                        </template>
                        <template v-else>
                          &#8377;{{
                            items.discountPrice ? items.discountPrice : 0
                          }}
                        </template> -->
                      </p>
                    </div>
                  </div>
                  <div class="w-1/5 flex justify-center">
                    <feather-icon
                      block
                      icon="Trash2Icon"
                      svgClasses="w-7"
                      class="ftr-bin-clr cursor-pointer"
                      @click="removeCart(item)"
                    ></feather-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:w-1/3 w-full px-4 pt-6">
          <div
            class="rounded-xl p-6 border-2 border-primary"
            v-if="cartData.length > 0"
          >
            <p class="text-black footertitle font-bold fsize24-14px mb-4">
              Order Summary
            </p>

            <div class="mt-8">
              <div class="flex justify-between">
                <p class="text-lg">Original Price</p>
                <p class="text-black font-semibold">
                  Rs. {{ totalPrice.toFixed(2) }}
                </p>
              </div>
              <!-- <div class="flex justify-between">
                <p class="text-lg">Coupon Discount</p>
                <p class="text-black font-semibold">Rs. 0.00</p>
              </div> -->
              <template
                v-if="
                  Object.keys(getUserByUserId).length !== 0 &&
                  Object.hasOwn(getUserByUserId, 'currentMembership')
                "
              >
                <div class="flex justify-between">
                  <p class="text-lg">Membership Discount</p>
                  <p class="text-black font-semibold">
                    Rs.
                    {{
                      (
                        totalPrice *
                        (getUserByUserId.currentMembership.discount / 100)
                      ).toFixed(2)
                    }}
                  </p>
                </div>
              </template>
              <hr class="my-2" />
              <template
                v-if="
                  Object.keys(getUserByUserId).length !== 0 &&
                  Object.hasOwn(getUserByUserId, 'currentMembership')
                "
              >
                <div class="flex justify-between">
                  <p class="text-lg font-semibold text-black">Total Price</p>
                  <p class="text-black font-semibold">
                    Rs.
                    {{
                      (
                        totalPrice -
                        totalPrice *
                          (getUserByUserId.currentMembership.discount / 100)
                      ).toFixed(2)
                    }}
                  </p>
                </div>
              </template>
              <template v-else>
                <div class="flex justify-between">
                  <p class="text-lg font-semibold text-black">Total Price</p>
                  <p class="text-black font-semibold">
                    Rs. {{ totalPrice.toFixed(2) }}
                  </p>
                </div>
              </template>
            </div>
            <b-button
              variant="primary"
              class="w-full border-0 mt-8 py-3 cartchkoutbtn"
              @click="handleClick('e-my-learning')"
              ><p class="fsize18 font-medium text-white">Checkout</p>
            </b-button>
          </div>
          <!-- @click="handleClick('payment')" -->
          <!-- <div class="rounded-xl p-6 border-2 border-primary mt-6">
            <p class="text-black footertitle font-bold fsize24-14px mb-4">
              Apply Coupon Code
            </p>
            <div class="flex w-full">
              <div class="w-4/6 pr-1">
                <b-form-input
                  placeholder="Enter coupon code"
                  class="inpt-bg-cp-cd"
                ></b-form-input>
              </div>
              <div class="w-2/6 pl-1">
                <b-button variant="outline-primary" class="w-full"
                  >Verify</b-button
                >
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NoData from "../../product/NoData.vue";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      cartData: [],
      discountPrice: [],
      courseId: [],
      student_id: "",
      cartId: [],
      value1: "",
      uservalue: {},
      totalPrice: 0,
      coursesList: [],
      currTransactionId: "",
    };
  },
  methods: {
    // hideModal() {
    //   this.$refs["cartout"].hide();
    // },

    async handleClick() {
      // this.$router.push({ name: name });

      // const payload = {
      //   key: "rzp_test_7EKPwE5AS31SYX",

      //   // key: "rzp_live_G3QRRpsJIC2LQE",
      //   amount: 100 * 100,
      //   currency: "INR",
      //   name: "Brained",
      //   order_id: "xyz",

      //   description: "Test Transaction",
      //   handler: function(response) {
      //     if (response.razorpay_payment_id) alert(response.razorpay_payment_id);
      //     // alert(response.razorpay_order_id);
      //     // alert(response.razorpay_signature)
      //     // self.$router.push({ name: "thank-you" });
      //     alert("thank you for your payment");
      //   },
      //   prefill: {
      //     name: "rishabh"
      //   }
      // };
      // const rzp1 = new window.Razorpay(payload);
      // rzp1.open();
      this.courses.forEach((e) => {
        e.forEach((el) => {
          this.coursesList.push(el._id);
        });
      });
      let self = this;
      // this.currMembership = membership;
      // console.log(this.currMembership);
      // console.log(this.user);
      if (this.totalPrice <= 0) {
        try {
          let status = await this.$store.dispatch("placeOrder/order", {
            course: this.coursesList,
            student: this.userData.student.userId,
          });
          if (status.code == 200) {
            const removeCartItems = await this.$store.dispatch(
              "cart/removeItems",
              {
                student: this.userData.student._id,
                cartId: this.cartId,
                course: this.courseId,
              }
            );
            this.$store.commit(
              "auth/userCartDelete",
              removeCartItems.removeCartItems
            );
            this.$swal.fire({
              title: "Order Placed!!!",

              text: "Your order has been placed Successfully!",

              icon: "success",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });

            await this.getAllStudents();
            this.$router.push({ name: "e-my-learning" });
          } else if (status.code == 401) {
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Please Login again to continue",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
          return;
        } catch (error) {
          console.log(error);
        }
      }
      let totalPrice = 0;
      if (
        Object.keys(this.getUserByUserId).length !== 0 &&
        Object.hasOwn(this.getUserByUserId, "currentMembership")
      ) {
        totalPrice = parseInt(
          (
            this.totalPrice -
            this.totalPrice *
              (this.getUserByUserId.currentMembership.discount / 100)
          ).toFixed(2)
        );
      } else {
        totalPrice = parseInt(this.totalPrice);
      }

      // const totalPrice = parseInt(this.currMembership.price);
      var amount = Number(totalPrice) * 100;
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        // console.log("HANDLEPAYMENTRECORD:", responcenew);
        this.currTransactionId = responcenew.data._id;
        if (responcenew) {
          const payload = {
            paymentAmt: parseInt(totalPrice),
            transactionId: responcenew.data._id,
            courses: this.coursesList,
            student: this.userData.student._id,
            orderId: responcenew.data.orderId,
            paymentStatus: "success",
          };

          let loader = this.$loading();
          try {
            const data = await this.$store.dispatch(
              "placeOrder/placeOrder",
              payload
            );
            // console.log("PAYMENTCREATE:", data);
            if (data.code == 200) {
              // this.success();
              // this.renderOperation();
              // this.$vs.loading.close();
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };
              await this.$store.dispatch("placeOrder/order", {
                course: this.coursesList,
                student: this.userData.student.userId,
              });
              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );
              let getUserPayload = {
                userId: this.user._id,
              };
              const getUser = await this.$store.dispatch(
                "auth/getUserByUserId",
                getUserPayload
              );
              // console.log("GETUSERBYUSERID:", this.getUserByUserId);
              loader.close();
              // console.log("payment success");
              const status = await this.$store.dispatch(
                "placeOrder/updateStatus",
                {
                  _id: data.data._id,
                  status: "success",
                }
              );
              if (status.code == 200) {
                const removeCartItems = await this.$store.dispatch(
                  "cart/removeItems",
                  {
                    student: this.userData.student._id,
                    cartId: this.cartId,
                    course: this.courseId,
                  }
                );
                this.$store.commit(
                  "auth/userCartDelete",
                  removeCartItems.removeCartItems
                );
                this.$swal.fire({
                  title: "Order Placed!!!",

                  text: "Your order has been placed Successfully!",

                  icon: "success",
                  showConfirmButton: false,
                  showCancelButton: false,
                  timer: 2000,
                });

                await this.getAllStudents();
                this.$router.push({ name: "e-my-learning" });
              } else if (status.code == 401) {
                this.$router.push({ name: "signin" });
                this.$swal.fire({
                  title: "Session Expired",
                  text: "Your session has ended and for security reasons, we request you to login again",
                  icon: "warning",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              }

              // this.$router.push({ name: "myorder" });
            }
            loader.close();
          } catch (error) {
            // this.$vs.loading.close();
            // this.error(error);
            loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          amount: Number(amount),
        })
        .then(async (_) => {
          // console.log(_);
          if (Object.keys(_.data).length == 0) {
            // return this.$notify.error({
            //   message: "Payment failed",
            //   position: "bottom-right",
            // });
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Courses Id: ${this.coursesList} `,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          // this.checkoutMessage = "Out of Stock",
          //  this.$notify.error({
          //     message: "Out of Stock",
          //     position: "bottom-right",
          //   })
          console.log(error);
        });

      // this.cartData.map((items) => {
      //   items.course.map((data) => this.courseId.push(data._id));
      // });
      // //console.log(this.cartData);
      // // console.log(items.courses);
      // const order = await this.placeOrder();
      // // console.log(order);
      // const status = await this.$store.dispatch("placeOrder/updateStatus", {
      //   _id: order._id,
      //   status: "success",
      // });
      // if (status.code == 200) {
      //   const removeCartItems = await this.$store.dispatch("cart/removeItems", {
      //     student: this.userData.student._id,
      //     cartId: this.cartId,
      //     course: this.courseId,
      //   });
      //   this.$store.commit(
      //     "auth/userCartDelete",
      //     removeCartItems.removeCartItems
      //   );
      //   this.$swal.fire({
      //     title: "Order Placed!!!",

      //     text: "Your order has been placed Successfully!",

      //     icon: "success",
      //     showConfirmButton: false,
      //     showCancelButton: false,
      //     timer: 2000,
      //   });

      //   await this.getAllStudents();
      //   this.$router.push({ name: "e-my-learning" });
      // } else if (status.code == 401) {
      //   this.$router.push({ name: "signin" });
      //   this.$swal.fire({
      //     title: "Session Expired",
      //     text: "Your session has ended and for security reasons, we request you to login again",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      // }
      // console.log(data);
    },
    placeOrder() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch("placeOrder/placeOrder", {
            transactionId: "abc",
            orderId: "xyz",
            courses: this.courseId,
            student: this.userData.student._id,
            paymentAmt: "100",
          });
          resolve(data);
        } catch (error) {
          reject(error);

          if (error.response.data.code == 401) {
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Your session has ended and for security reasons, we request you to login again",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
      });
    },
    async getAllStudents() {
      // this.totalPrice = 0;
      // await this.$store.dispatch("student/getStudents");

      // const studentId = this.userData._id;

      // this.students.map((items) => {
      //   if (items.userId.id == studentId) {
      //     this.student_id = items._id;
      //     this.cartData = items.cart;
      //   }
      // });
      // let payload = { _id: this.userData.student._id };
      try {
        const data = await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );

        this.cartData = data.data.cart;
        this.cartData.map((items) => {
          this.cartId.push(items._id);
          items.course.map((data) => {
            this.discountPrice.push(parseInt(data.discountPrice));
          });
        });
        const Total = this.discountPrice.reduce((a, b) => a + b, 0);
        if (isNaN(Total)) {
          this.totalPrice = 0;
        } else {
          this.totalPrice = Total;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async removeCart(item) {
      if (item._id && item._id.length !== 0) {
        try {
          const result = await this.$swal({
            title: "Are you sure?",
            html: `<p class="text-center">You won't be able to revert this!</p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
          });

          if (result.isConfirmed) {
            const index = this.cartData.indexOf(item);
            if (index > -1) {
              this.cartData.splice(index, 1);
            }

            const response = await this.$store.dispatch("cart/removeCart", {
              _id: item._id,
              cart: item._id,
              student: this.userData.student._id,
            });

            this.$store.commit("auth/userCartDelete", response.data);

            await this.$swal.fire({
              title: "Removed!",
              text: "Item has been removed.",
              icon: "success",
              confirmButtonColor: "#830c81",
            });

            await this.getAllStudents();
          }
        } catch (error) {
          console.error("Failed to remove cart item:", error);
          await this.$swal.fire({
            title: "Error",
            text: "Failed to remove item from cart. Please try again.",
            icon: "error",
            confirmButtonColor: "#830c81",
          });
        }
      }
    },
    init() {
      // console.log(this.cartData);
      // console.log(this.students);
      // console.log(this.userData.student._id);
      // this.uservalue = this.userData.student._id;
      // return this.uservalue;
      // console.log(this.userData);
    },
    async handlePaymentRecord(responce) {
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          courseId: this.coursesList,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        // console.log("TRANSACTIONCREATE:", transactionrecord);
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
      // console.log("FAILEDTRANSACTIONRESPONSE", data);
    },
  },
  watch: {
    totalPrice(newVal, oldVal) {
      this.totalPrice = newVal;
    },
  },
  async mounted() {
    // this.totalPrice = 0;
    if (Object.keys(this.user).length != 0) {
      let payload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        payload
      );
    }
    this.getAllStudents();
    this.init();
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("auth", ["userData"]),
    ...mapState("student", ["students"]),
    courses() {
      return this.cartData.map((items) => items.course);
    },
    cartPrices() {
      return this.courses.map((data) => parseInt(data[0].discountPrice));
    },
    // totalPrice() {
    //   return this.cartPrices.reduce((a, b) => a + b, 0);
    // },
  },
};
</script>
